<template>
  <div id="header" class="header">
    <div class="header-nav"><!-- 공백 --></div>
    <div class="header-gnb">
      <h1 class="logo">
        <a href="/index.html">
          <img src="../../../assets/images/common/ci-wavve.svg" alt="wavve"/>
        </a>
      </h1>
      <nav class="gnb-left">
        <ul>
          <li><a href="/customer/company.html" :class="classOn('company')">회사소개</a></li>
          <li><a href="/customer/business.html" :class="classOn('business')">사업제휴</a></li>
          <li><a href="/customer/financial_statements.html" :class="classOn('financial_statements')">투자정보</a></li>
        </ul>
      </nav>
    </div>
  </div>
</template>
<script>
  import _ from 'lodash'
  export default {
    name: 'CustomerHeader',
    methods: {
      classOn (name) {
        if (name === _.get(this.$route, 'name', '')) {
          return 'on'
        }
      }
    }
  }
</script>
<style scoped>
  .recruit .header-gnb .gnb-left{
    display: none;
  }
</style>
